import ReportModal from "./ReportModal";

export default ReportModal;